// Vaste, gecureerde foto's per concelho-slug. Wat hier staat wint van
// de automatische Wikipedia-foto. Vul aan met directe afbeeldings-URL's
// (jpg/png) — bv. van Wikimedia Commons (Special:FilePath/Bestand.jpg).
//
// Voorbeeld:
//   "aljezur": "https://upload.wikimedia.org/.../Aljezur.jpg",
//
// CSS-achtergronden hebben geen CORS nodig, dus elke publieke URL werkt.
export const PLACE_PHOTOS = {
  // "olhao": "https://upload.wikimedia.org/...",
};

export function curatedPhoto(slug) {
  return slug ? (PLACE_PHOTOS[slug] || null) : null;
}
